"use strict";

exports.__esModule = true;
exports.val = val;
/**
 * Create a getter for the value of a given theme key.
 */
function val(key) {
  return function (props) {
    return props.theme[key];
  };
}